<template>
  <div>
    <!-- FOOTER -->
    <footer>
      <!-- FOOTER TOP -->

      <div id="footer-top-wrap">
        <div id="footer-top">
          <!-- COMPANY INFO -->
          <div class="company-info">
            <p>
              Disclaimer: Cardholder's responsibility to know the laws
              concerning essay writing services in his or her country or state
              of domicile.
            </p>
            <br />
            <p>
              All products, services and written materials provided by our
              company are intended solely for research and reference purposes.
              Customers are not permitted to claim authorship of any content
              delivered by us. We strongly oppose plagiarism and all other forms
              of academic dishonesty, and do not condone, encourage or knowingly
              participate in any acts of academic fraud. All content obtained
              from our website must be properly referenced in accordance with
              your institution's policies and guidelines on research and
              academic integrity.
            </p>
          </div>
          <!-- /COMPANY INFO -->

          <!-- LINK INFO -->
          <div class="link-info">
            <p class="footer-title">Menu</p>
            <!-- LINK LIST -->
            <ul class="link-list">
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/">Homepage</a>
              </li>
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/how-it-works">How it works</a>
              </li>
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/writers">Top writers</a>
              </li>
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/prices">Prices</a>
              </li>
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/order">New order</a>
              </li>
            </ul>
            <!-- /LINK LIST -->
          </div>
          <!-- /LINK INFO -->

          <!-- LINK INFO -->
          <div class="link-info">
            <p class="footer-title">Company</p>
            <!-- LINK LIST -->
            <ul class="link-list">
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/about">About us</a>
              </li>
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/contact">Contact us</a>
              </li>
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/testimonials">Testimonials</a>
              </li>
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/become-a-freelance-writer"
                  >Become a freelance writer</a
                >
              </li>
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/faq">FAQ</a>
              </li>
            </ul>
            <!-- /LINK LIST -->
          </div>
          <!-- /LINK INFO -->

          <!-- LINK INFO -->
          <div class="link-info">
            <p class="footer-title">Legal</p>
            <!-- LINK LIST -->
            <ul class="link-list">
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/terms-and-conditions">Terms & Conditions</a>
              </li>
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/cookie-policy">Cookie Policy</a>
              </li>
              <li class="link-item">
                <div class="bullet"></div>
                <a href="/money-back-guarantee">Money Back Guarantee</a>
              </li>
            </ul>
            <!-- /LINK LIST -->
          </div>
          <!-- /LINK INFO -->

          <!-- LINK INFO -->
          <div class="link-info">
            <p class="footer-title">We accept</p>
            <!-- SOCIAL LINKS -->
            <ul class="payment-icons">
              <li class="payment-icon">
                <i class="fa fa-cc-visa" aria-hidden="true"></i>
              </li>
              <li class="payment-icon">
                <i class="fa fa-cc-mastercard" aria-hidden="true"></i>
              </li>
            </ul>
            <!-- /SOCIAL LINKS -->
          </div>
          <!-- /LINK INFO -->
        </div>
      </div>
      <!-- /FOOTER TOP -->

      <!-- FOOTER BOTTOM -->
      <div id="footer-bottom-wrap">
        <div id="footer-bottom">
          <p>
            2021 <span>&copy;</span> <a href="/">{{ website }}</a> All rights
            reserved.
          </p>
        </div>
      </div>
      <!-- /FOOTER BOTTOM -->
    </footer>
    <!-- /FOOTER -->

    <div class="shadow-film closed"></div>

    <!-- SVG ARROW -->
    <svg style="display: none;">
      <symbol
        id="svg-arrow"
        viewBox="0 0 3.923 6.64014"
        preserveAspectRatio="xMinYMin meet"
      >
        <path
          d="M3.711,2.92L0.994,0.202c-0.215-0.213-0.562-0.213-0.776,0c-0.215,0.215-0.215,0.562,0,0.777l2.329,2.329
			L0.217,5.638c-0.215,0.215-0.214,0.562,0,0.776c0.214,0.214,0.562,0.215,0.776,0l2.717-2.718C3.925,3.482,3.925,3.135,3.711,2.92z"
        />
      </symbol>
    </svg>
    <!-- /SVG ARROW -->

    <!-- SVG STAR -->
    <svg style="display: none;">
      <symbol
        id="svg-star"
        viewBox="0 0 10 10"
        preserveAspectRatio="xMinYMin meet"
      >
        <polygon
          points="4.994,0.249 6.538,3.376 9.99,3.878 7.492,6.313 8.082,9.751 4.994,8.129 1.907,9.751
	2.495,6.313 -0.002,3.878 3.45,3.376 "
        />
      </symbol>
    </svg>
    <!-- /SVG STAR -->

    <!-- SVG PLUS -->
    <svg style="display: none;">
      <symbol
        id="svg-plus"
        viewBox="0 0 13 13"
        preserveAspectRatio="xMinYMin meet"
      >
        <rect x="5" width="3" height="13" />
        <rect y="5" width="13" height="3" />
      </symbol>
    </svg>
    <!-- /SVG PLUS -->

    <!-- SVG CHECK -->
    <svg style="display: none;">
      <symbol
        id="svg-check"
        viewBox="0 0 15 12"
        preserveAspectRatio="xMinYMin meet"
      >
        <polygon
          points="12.45,0.344 5.39,7.404 2.562,4.575 0.429,6.708 3.257,9.536 3.257,9.536
			5.379,11.657 14.571,2.465 "
        />
      </symbol>
    </svg>
    <!-- /SVG CHECK -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      website: window.config.website,
    };
  },
};
</script>
